import { getMessages } from '../../../../../../../store/constants';

export const IDK_CHUWAK_ITEM = getMessages().getText('move_to_chuwak');
export const MORE_BOARDS_ITEM = getMessages().getText('move_to_more_boards_item');
export const MAKE_FIRST_ITEM = getMessages().getText('move_to_make_first_item');
